import fp from 'lodash/fp'
import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withFormModel, withMobxAutorun } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { ServicesContext } from 'services/context'

import BeneficiaryFiltersComponent from './component'
import {
  formatCategories,
  formatSubcategories,
  toSearchableCategory,
} from './helpers'

const { custom } = validators

export const BeneficiaryFilters = combine(
  withContext(
    'taxonomyService',
    ServicesContext,
    ({ taxonomyService }) => taxonomyService
  ),

  withFormModel(
    {
      search: {
        initialValue: '',
        spec: spec.flow(custom.valid),
      },
      categories: spec.flow(custom.valid),
      subCategories: spec.flow(custom.valid),
    },
    { id: 'beneficiary-filters-form' }
  ),

  withCallbacks(
    {
      getOptionLabel:
        () =>
        ({ name }) =>
          name,
      getOptionValue:
        () =>
        ({ id }) =>
          id,

      loadCategories:
        ({ taxonomyService }) =>
        () =>
          taxonomyService.queryBeneficiaryCategories().then(formatCategories),

      loadSubcategories:
        ({ taxonomyService }) =>
        () =>
          taxonomyService
            .queryBeneficiarySubcategories()
            .then(formatSubcategories),

      onSearchRequest: {
        deps: ['debounce', 'onSearch'],
        func: (_state, { debounce, onSearch }) => {
          return fp.isNumber(debounce)
            ? fp.debounce(debounce, onSearch)
            : onSearch
        },
      },
    },
    []
  ),

  withMobxAutorun(
    ({ firstRun, state: { form, onSearchRequest } }) => {
      const search = form.getControl('search')
      const categories = form.getControl('categories')
      const subCategories = form.getControl('subCategories')
      const beneficiaryName = search.value
      const categoriesQuery = categories.value
      const subCategoriesQuery = subCategories.value

      if (firstRun) {
        return
      }

      onSearchRequest({
        beneficiaryName,
        categories: toSearchableCategory(categoriesQuery),
        subCategories: toSearchableCategory(subCategoriesQuery),
      })
    },
    ['onSearchRequest']
  )
)(BeneficiaryFiltersComponent)
